import { supabase } from '../../lib/clients/supabase';

export const squareOAuth = {
  // Generate OAuth URL for Square
  generateOAuthUrl: () => {
    const state = crypto.randomUUID();
    const redirectUri = encodeURIComponent(process.env.REACT_APP_SQUARE_REDIRECT_URI);
    
    return `https://connect.squareup.com/oauth2/authorize?` +
      `client_id=${process.env.REACT_APP_SQUARE_APPLICATION_ID}` +
      `&scope=PAYMENTS_WRITE+PAYMENTS_READ+ORDERS_WRITE+ORDERS_READ` +
      `&session=false` +
      `&state=${state}` +
      `&redirect_uri=${redirectUri}`;
  },

  // Handle OAuth callback
  handleOAuthCallback: async (code, state) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SUPABASE_FUNCTION_URL}/square-oauth-callback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code, state }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to complete OAuth flow');
      }

      return result;
    } catch (error) {
      console.error('Square OAuth callback error:', error);
      throw error;
    }
  },

  // Get merchant's Square integration status
  getIntegrationStatus: async () => {
    try {
      const { data, error } = await supabase
        .from('merchant_integrations')
        .select('*')
        .eq('integration_type', 'square')
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error fetching Square integration status:', error);
      throw error;
    }
  },

  // Disconnect Square integration
  disconnectIntegration: async () => {
    try {
      const { error } = await supabase
        .from('merchant_integrations')
        .delete()
        .eq('integration_type', 'square');

      if (error) throw error;
      return true;
    } catch (error) {
      console.error('Error disconnecting Square integration:', error);
      throw error;
    }
  }
}; 